
import XHeader from 'vux/src/components/x-header/index.vue'

import { get } from 'http';

export default {
components: {
XHeader
},
data () {
return {
showLeft: false,
article: null,
model:{},
classifyList: [],
history_id: -1,
history_obj: null,
flag: true
}
},
created(){
this.helpTypeId=this.$route.query.helpTypeId
this.helpTypeName= this.$route.query.helpTypeName
this.helpTypePName=this.$route.query.helpTypePName
this.id=this.$route.query.id
this.history_id=this.id


this.addClickNumber(this.id)
this.getHelpType()
},
methods: {
goBack(){
this.$router.push({
path : '/developer/newbieGuide',
query : {}
})
},
getDetail(id){
var sef=this
this.$http.post(this.global.httpUrl + '/rest/v1/m/mhelp/getDetail',{articleId: id},{emulateJSON:true}).then(function(res){

if(res.body.success)
{
sef.article=res.body.article


sef.article.content= sef.article.content.replace(/<img[^>]*>/gi, function (match, capture) {
match=match.replace(/width="[^"]*?"/g,'');
match= match.replace(/height="[^"]*?"/g,'');
match=match.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, 'style="float: left;"') 
return match;
})
}
},function(res){
console.log(res.status);
});
},
addClickNumber(id){
var sef=this
this.$http.post(this.global.httpUrl + '/rest/v1/m/mhelp/addClickNumber',{articleId: id},{emulateJSON:true}).then(function(res){

if(res.body.success)
{
this.getDetail(id)
}else{
console.log('点击数修改失败');
}
},function(res){
console.log(res.status);
});
},
getArticle(helpTypeId,helpTypeName,helpTypePName,id,obj){
if(this.history_id!=-1 && this.history_id==id){
return;
}else{
this.history_id=id;
}

for(var i=0;i<this.classifyList.length;i++){
for(var j=0;j<this.classifyList[i].level_2.length;j++){
for(var k=0;k<this.classifyList[i].level_2[j].articleList.length;k++){
this.classifyList[i].level_2[j].articleList[k].v_style={color:'#666'}
}
}
}

obj.v_style={color:'#26a2ff'}

this.helpTypeName=helpTypeName;
this.showLeft=false










this.addClickNumber(id)
},
showDir(){
this.showLeft=true
for(var i=0;i<this.classifyList.length;i++){
if(this.classifyList[i].helpTypeName==this.helpTypePName){
this.classifyList[i].flag=true
}
for(var j=0;j<this.classifyList[i].level_2.length;j++){
if(this.classifyList[i].level_2[j].helpTypeName==this.helpTypeName){
this.classifyList[i].level_2[j].flag=true
}
for(var k=0;k<this.classifyList[i].level_2[j].articleList.length;k++){
if(this.classifyList[i].level_2[j].articleList[k].id==this.article.id){
this.classifyList[i].level_2[j].articleList[k].v_style={color:'#26a2ff'}
}
}
}
}
},
getPh(index,obj){
this.classifyList[index].flag = !this.classifyList[index].flag
if(!this.classifyList[index].flag){
for(var j=0;j<this.classifyList[index].level_2.length;j++){
this.classifyList[index].level_2[j].flag=false
}
}
let tempArr = JSON.parse(JSON.stringify(this.classifyList))
this.classifyList = []
this.$nextTick(() => {
this.classifyList = tempArr
})
},
getArticleList(index1,index2,e){
var obj=e.currentTarget;
var sef=this;

if(obj.classList.contains("open") && sef.classifyList[index1].level_2[index2].flag){
obj.classList.remove("open")
sef.classifyList[index1].level_2[index2].flag=false;
return;
}else{
obj.classList.add("open")
sef.classifyList[index1].level_2[index2].flag=true;
}

},
getHelpType(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/mhelp/getDetailList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.classifyList = res.body.rows;
}
},function(res){
console.log(res.status);
});
}
}
}



// WEBPACK FOOTER //
// ./src/views/developer/developerDetail.vue